export default {
  init() {

  },
  finalize() {
    function customiseSelects() {
      if ($('.gform_body select').length > 0) {
        $('.gform_body select').each(function() {
          if (!$(this).hasClass('custom_select_done')) {
            $(this).customSelect();
            $(this).addClass('custom_select_done');
          }
        })
      }
    }

    customiseSelects();

    setInterval(function() {
      customiseSelects();
    }, 1000);

    $('.gform_fileupload_multifile').on('dragover dragenter', function() {
      $(this).find('.gform_drop_area').addClass('drag_enter');
      $(this).find('.gform_button_select_files').hide();
      $(this).find('.gform_drop_instructions').html('Drop your files here');
    });
    
    $('.gform_fileupload_multifile').on('drop dragleave', function() {
      $(this).find('.gform_drop_area').removeClass('drag_enter');
      $(this).find('.gform_button_select_files').show();
      $(this).find('.gform_drop_instructions').html('Drop files here or');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-contact.js